import Box from "@mui/material/Box";
import React from "react";

type Props = {
	children: JSX.Element;
};

// Desktop pages keep the 1364px floor their wide tables were built for. Below
// 900px (the phone layout) the floor is dropped so the page fits the screen and
// wide content scrolls inside its own container instead of the whole frame.
// A page that scrolls its own wide content (the roster timeline) marks itself
// with data-fit-screen and drops the floor at every width.
const PageLayout = ({ children }: Props) => {
	return (
		<Box
			component='main'
			sx={{
				flexGrow: 1,
				backgroundColor: "#fff",
				borderRadius: { xs: "12px", md: "15px" },
				minWidth: { xs: 0, md: "1364px" },
				m: { xs: 1, md: 3 },
				"&:has([data-fit-screen])": { minWidth: 0 },
			}}
		>
			{children}
		</Box>
	);
};

export default PageLayout;
